import { CCol, CContainer, CRow } from "@coreui/react";
import React from "react";
import Banner from "../components/Common/Banner";
import AboutBanner from "../assests/bg-about.png";
import staticData from "../assests/staticData.json";

import ServiceList from "../components/Common/ServiceList";
export default function Accommodation() {
  const { accommodation_service } = staticData;

  return (
    <>
      <Banner
        banner={AboutBanner}
        subtext={"Registered NDIS Provider"}
        text={accommodation_service.service_title}
      />
      <section className="services-layout-wrapper">
        <CContainer>
          <CRow>
            <CCol lg={9}>
              <div className="service-detail-wrapper">
                <img
                  src={require(`../assests/${accommodation_service.service_image}`)}
                  alt={accommodation_service.service_title}
                  className="mb-5 img-fluid w-100"
                />
                <h1>{accommodation_service.service_title}</h1>
                {accommodation_service.service_desc.map((desc, index) => (
                  <p key={index} className="themeGrayPara in-fs lh-28">
                    {desc}
                  </p>
                ))}
              </div>
            </CCol>
            <CCol lg={3}>
              <div className="service-list-wrapper">
                <ServiceList />
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
